import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { Capacitor } from '@capacitor/core';
import { config } from './config';

// Initialize Firebase
const app = initializeApp(config.firebase);

// Only initialize messaging for web platform
// Native platforms use Capacitor Push Notifications instead
let messaging: any = null;

if (!Capacitor.isNativePlatform()) {
  try {
    messaging = getMessaging(app);
  } catch (error) {
    console.warn('Firebase messaging not available:', error);
  }
}

export { messaging, getToken, onMessage };
